// Event delegation for quick-add-anchor (works even before custom element initializes)
// This is a fallback in case custom element hasn't initialized yet
(function() {
  let delegationActive = true;
  
  document.addEventListener('click', function(e) {
    if (!delegationActive) return;
    
    const anchor = e.target.closest('.quick-add-anchor');
    if (!anchor) return;
    
    // Check if anchor already has a handler (custom element initialized)
    const productForm = anchor.closest('product-form');
    if (!productForm) return;
    
    // If custom element has onAnchorClick method, let it handle (but it should have stopped propagation)
    // Otherwise, handle it here as fallback
    const form = productForm.querySelector('form');
    if (!form) return;
    
    const submitBtn = productForm.querySelector('[type="submit"]') || form.querySelector('button[name="add"]');
    
    if (submitBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Temporarily make button clickable
      const originalStyle = submitBtn.style.cssText;
      submitBtn.style.position = 'static';
      submitBtn.style.opacity = '1';
      submitBtn.style.pointerEvents = 'auto';
      submitBtn.style.width = 'auto';
      submitBtn.style.height = 'auto';
      submitBtn.style.overflow = 'visible';
      
      const wasDisabled = submitBtn.disabled || submitBtn.getAttribute('aria-disabled') === 'true';
      if (wasDisabled) {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-disabled');
      }
      
      // Small delay to ensure button is ready
      setTimeout(function() {
        submitBtn.click();
        
        // Restore original state
        submitBtn.style.cssText = originalStyle;
        if (wasDisabled) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-disabled', 'true');
        }
      }, 10);
    }
  }, true); // Use capture phase - intercept early
})();

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');         
      if(!this.form) return;
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      
      // Handle anchor tag click for quick add (to prevent swiper slide change)
      this.quickAddAnchor = this.querySelector('.quick-add-anchor');
      if (this.quickAddAnchor) {
        this.quickAddAnchor.addEventListener('click', this.onAnchorClick.bind(this));
      }
    }
    
    onAnchorClick(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();
      
      // Check if product is available
      if (this.quickAddAnchor.getAttribute('aria-disabled') === 'true') {
        return;
      }
      
      // Find the submit button - try multiple selectors
      const submitBtn = this.querySelector('[type="submit"]') || 
                        this.querySelector('button[name="add"]') ||
                        this.form.querySelector('[type="submit"]');
      
      // Method 1: Trigger click on submit button (most reliable)
      if (submitBtn) {
        // Temporarily make button visible and clickable for the click event
        const originalStyle = submitBtn.style.cssText;
        submitBtn.style.position = 'static';
        submitBtn.style.opacity = '1';
        submitBtn.style.pointerEvents = 'auto';
        submitBtn.style.width = 'auto';
        submitBtn.style.height = 'auto';
        submitBtn.style.overflow = 'visible';
        
        // Enable the button if it's disabled
        const wasDisabled = submitBtn.disabled || submitBtn.getAttribute('aria-disabled') === 'true';
        if (wasDisabled) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-disabled');
        }
        
        // Trigger click
        submitBtn.click();
        
        // Restore original state
        submitBtn.style.cssText = originalStyle;
        if (wasDisabled) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-disabled', 'true');
        }
        return;
      }
      
      // Method 2: Try using form.requestSubmit() (if available)
      if (this.form && typeof this.form.requestSubmit === 'function') {
        this.form.requestSubmit();
        return;
      }
      
      // Method 3: Fallback - dispatch submit event directly
      if (this.form) {
        const submitEvent = new Event('submit', { 
          bubbles: true, 
          cancelable: true 
        });
        this.form.dispatchEvent(submitEvent);
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      
      // Check if already disabled (prevent double submission)
      const submitBtn = this.submitButton || this.querySelector('[type="submit"]');
      if (submitBtn && submitBtn.getAttribute('aria-disabled') === 'true') {
        return;
      }

      this.handleErrorMessage();

      // Update both submit button and anchor if exists
      if (this.submitButton) {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
      }
      if (this.quickAddAnchor) {
        this.quickAddAnchor.setAttribute('aria-disabled', 'true');
        this.quickAddAnchor.classList.add('loading');
      }
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      // Check if fetchConfig is available, otherwise use inline config
      const config = typeof fetchConfig === 'function' 
        ? fetchConfig('javascript') 
        : { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' } };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);   
      
       if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

      
      config.body = formData;
    

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
            console.log(Object.fromEntries(formData.entries()));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.submitButton) {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          }
          if (this.quickAddAnchor) {
            this.quickAddAnchor.classList.remove('loading');
            if (!this.error) this.quickAddAnchor.removeAttribute('aria-disabled');
          }
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          const spinner = this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');          
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

